import React from "react";
import "./DropDown.scss";
import Dropdown from "react-dropdown";
import Icon from "../Icon";

export default function DropDown({ options, value, onChange, zindex = 0, className }) {
  
  return (
    <div style={{zIndex: zindex}}>
      <Dropdown className={className} options={options.filter(e => e !== (value ? value : options[0]))} onChange={(e) => onChange(e.value)} value={value ? value : options[0]} arrowClosed={<Icon icon="arrow-down" height={15} size={15} />} arrowOpen={<Icon icon="arrow-up" height={15} size={15} />} />
      {/* <Dropdown className={className} options={options} onChange={(e) => onChange(e.value)} value={value ? value : options[0]} arrowClosed={<Icon icon="arrow-down" height={15} size={15} />} arrowOpen={<Icon icon="arrow-up" height={15} size={15} />} /> */}
    </div>
  );
}
